import { publish } from "@Libs/Events/services/events";
import { IRecordEvent, IRecordEventList } from "@Libs/Events/types/event.types";

function getDeviceType() {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 767) {
    return "mobile";
  } else if (screenWidth >= 768 && screenWidth <= 1024) {
    return "tablet";
  } else {
    return "desktop";
  }
}

declare global {
  interface Window {
    publishServerEvent: (
      eventName: string,
      payload: {
        metadata: object;
        data: object;
      },
      on?: string
    ) => void;
  }
}

window.publishServerEvent = (
  key: IRecordEvent<keyof IRecordEventList>["key"],
  payload: IRecordEvent<keyof IRecordEventList>["payload"],
  on = null
) => {
  const event: IRecordEvent<keyof IRecordEventList> = {
    key,
    payload: {
      data: payload.data,
      metadata: {
        system: "web",
        deviceType: getDeviceType(),
        ...payload.metadata,
      },
    },
  };

  if (on) {
    window.addEventListener(on, () => {
      publish(event);
    });
  } else publish(event);
};
